import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Layout({ children, title }) {
  const { user, logout, isAdmin, canCreate } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const navItems = [
    { path:'/',        icon:'fa-gauge',      label:'Dashboard' },
    { path:'/tickets', icon:'fa-list-check', label:'All Tickets' },
    ...(canCreate ? [{ path:'/tickets/new', icon:'fa-plus', label:'New Ticket' }] : []),
  ];
  const adminItems = [
    { path:'/users',     icon:'fa-users',   label:'User Management' },
    { path:'/dropdowns', icon:'fa-sliders', label:'Dropdown Manager' },
  ];

  const roleConfig = {
    admin:         { color:'#e24b4a', label:'Admin'         },
    user:          { color:'#6382e6', label:'User'          },
    sales_manager: { color:'#5DCAA5', label:'Sales Manager' },
    fullviewer:    { color:'#EF9F27', label:'Full Viewer'   },
  };
  const rc = roleConfig[user?.role] || { color:'#888', label: user?.role };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <h2><i className="fa-solid fa-ticket"></i> TE Tracker</h2>
          <span>Support Management</span>
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <div key={item.path}
              className={`nav-item ${pathname === item.path ? 'active' : ''}`}
              onClick={() => navigate(item.path)}>
              <i className={`fa-solid ${item.icon}`}></i>
              {item.label}
            </div>
          ))}
          {isAdmin && (
            <>
              <div style={{padding:'16px 16px 6px',fontSize:'10px',color:'rgba(255,255,255,0.3)',textTransform:'uppercase',letterSpacing:'0.08em'}}>Admin</div>
              {adminItems.map(item => (
                <div key={item.path}
                  className={`nav-item ${pathname === item.path ? 'active' : ''}`}
                  onClick={() => navigate(item.path)}>
                  <i className={`fa-solid ${item.icon}`}></i>
                  {item.label}
                </div>
              ))}
            </>
          )}
        </nav>
        <div className="sidebar-footer">
          <div className="user-name">{user?.full_name}</div>
          <div style={{marginTop:3}}>
            <span style={{
              fontSize:10, padding:'2px 7px', borderRadius:99,
              background: rc.color, color:'#fff', fontWeight:500
            }}>{rc.label}</span>
          </div>
          <div style={{marginTop:10,display:'flex',gap:8}}>
            <span style={{cursor:'pointer',fontSize:12,color:'rgba(255,255,255,0.5)'}}
              onClick={() => navigate('/change-password')}>
              <i className="fa-solid fa-key"></i> Password
            </span>
            <span style={{cursor:'pointer',fontSize:12,color:'rgba(255,255,255,0.5)',marginLeft:8}}
              onClick={logout}>
              <i className="fa-solid fa-right-from-bracket"></i> Logout
            </span>
          </div>
        </div>
      </aside>
      <div className="main-content">
        <div className="topbar">
          <div className="topbar-title">{title}</div>
          <div className="topbar-right">
            <span style={{fontSize:12,color:'#888'}}>
              <i className="fa-solid fa-circle" style={{color:'#4ade80',fontSize:8,marginRight:5}}></i>
              Connected
            </span>
          </div>
        </div>
        <div className="page">{children}</div>
      </div>
    </div>
  );
}
